export const LIBRARY_HELP_COPY = {
  heading: "How Tech Leaders helps",
  description:
    "We help you and your team put AI to work. That means practical training and hands-on help building and improving agents around your real tasks.",
  invitation:
    "Bring this workflow and your team’s priorities to AI 30: 30 days of practical training, workflow building, and adoption support. Smaller cohorts are welcome.",
};
